import { render } from "./onlyKeysTablePages.vue?vue&type=template&id=057dd99d&scoped=true"
import script from "./onlyKeysTablePages.vue?vue&type=script&lang=js"
export * from "./onlyKeysTablePages.vue?vue&type=script&lang=js"

import "./onlyKeysTablePages.vue?vue&type=style&index=0&id=057dd99d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057dd99d"]])

export default __exports__